import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Liest `bundles.is_active` für ein Bundle. Wird u. a. vom Mega-Menu
 * verwendet, um neue Ausbildungen erst bei Freischaltung anzuzeigen.
 */
export function useBundleActive(bundleId: string | null | undefined) {
  return useQuery({
    queryKey: ["bundle-is-active", bundleId],
    enabled: !!bundleId,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<boolean> => {
      if (!bundleId) return false;
      const { data, error } = await supabase
        .from("bundles")
        .select("is_active")
        .eq("id", bundleId)
        .maybeSingle();
      if (error) throw error;
      return data?.is_active ?? false;
    },
  });
}
